import { useEffect, useState, useContext, useRef } from 'react'
import { useTheme } from '@mui/material/styles'
import { Stack, Box, Typography } from '@mui/material'
import { motion, useMotionValueEvent } from 'framer-motion'

export const Logo = () => {
	const theme = useTheme()

	return (<motion.div
		style={{
			width: "54px",
			height: "54px",
			display: 'flex',
			borderRadius: 10,
			marginLeft: 34,
			backgroundColor: theme.palette.white[0],
			cursor: 'pointer',
		}}
		initial={{
			boxShadow: '0 4px 30px rgba(0, 0, 0, 0)',
		}}
		animate={{
			boxShadow: '0 4px 30px rgba(0, 0, 0, 0.3)',
		}}
		whileTap={{
			scale: 0.9,
		}}
		// transition={{ delay: 0.5, duration: 0.4, ease: 'easeIn' }}
	>
		<motion.svg
			viewBox="0 0 128 128"
			style={{ opacity: 1, pointerEvents: 'none' }}>
			<motion.g style={{ fill: theme.palette.logo[0] }}>
				{[
					{
						path: 'm97.016,29.007c2.268,0,4.107,1.839,4.107,4.107v25.031c0,26.308-27.943,43.09-35.615,47.202-1.21.649-2.65.647-3.861-.002-2.226-1.192-6.154-3.448-10.609-6.69-1.593-1.159-2.152-3.283-1.319-5.069l29.005-62.208c.675-1.447,2.126-2.371,3.722-2.371h14.57Z',
					},
					{
						path: 'm76.802,31.296l-28.736,61.63c-.598,1.282-2.256,1.63-3.319.697-1.622-1.423-3.242-2.961-4.812-4.612-.623-.655-.772-1.637-.389-2.457l26.24-56.27c.363-.779,1.144-1.276,2.003-1.276h7.554c1.177,0,1.955,1.222,1.458,2.288Z',
					},
					{
						path: 'm60.367,31.379l-23.491,50.369c-.515,1.104-2.035,1.238-2.736.242-.771-1.095-1.504-2.227-2.194-3.391-.359-.606-.386-1.357-.088-1.996l21.62-46.361c.351-.754,1.108-1.235,1.939-1.235h3.439c1.219,0,2.026,1.266,1.511,2.371Z',
					},
					{
						path: 'm46.943,30.822l-17.116,36.719c-.557,1.194-2.316,1.039-2.639-.239-.227-.899-.422-1.811-.582-2.736-.06-.349-.008-.71.141-1.031l15.635-33.534c.283-.607.892-.995,1.562-.995h1.842c.933,0,1.551.969,1.156,1.815Z',
					},
					{
						path: 'm35.757,30.273l-8.024,17.217c-.402.863-1.696.576-1.696-.376v-1.077c0-.13.028-.258.083-.376l7.522-16.14c.146-.314.461-.514.807-.514h.502c.651,0,1.082.676.807,1.266Z',
					},
					{
						path: 'm27.7,29.007c.321,0,.534.334.398.625l-2.062,4.418v-4.604c0-.243.197-.439.439-.439h1.225Z',
					},
				].map((d, i) => (
					<motion.path
						key={d.path}
						d={d.path}
						initial={{
							fill: 'white',
							scale: 0,
							x: 5,
							y: 5,
							opacity: 1,
						}}
						animate={{
							opacity: 1,
							fill: theme.palette.logo[0],
							scale: 1,
							x: 0,
							y: 0,
						}}
						transition={{
							duration: 0.6,
							ease: 'easeInOut',
							delay: 0.1 + (5 - i) * 0.1,
						}}
					/>
				))}
			</motion.g>
			<motion.path
				style={{
					fill: 'none',
					stroke: theme.palette.logo[0],
					strokeWidth: 5,
					strokeLinecap: 'round',
				}}
				initial={{ pathLength: 0 }}
				animate={{ pathLength: 1 }}
				transition={{
					delay: 0.2,
					duration: 0.8,
					ease: 'easeInOut',
				}}
				d="m97.558,120.5H30.442c-12.67,0-22.942-10.271-22.942-22.942V30.442c0-12.67,10.271-22.942,22.942-22.942h67.116c12.67,0,22.942,10.271,22.942,22.942v67.116c0,12.67-10.271,22.942-22.942,22.942Z"
			/>
		</motion.svg>
	</motion.div>)
}
